import React from "react";
import AppText from "../../Core/AppText/AppText";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import LoadingIndicator from "../LoadingIndicator/LoadingIndicator";

interface EmptyStatePropTypes extends EmptyStateWrapperStyleProps {
	label: string;
	isLoading?: boolean;
}

interface EmptyStateWrapperStyleProps {
	margin?: string;
}

const EmptyState: React.FC<EmptyStatePropTypes> = ({ label, margin, isLoading }) => {
	const { t } = useTranslation();

	return (
		<EmptyStateWrapper margin={margin}>
			{isLoading ? (
				<LoadingIndicator size={"s"} showText={false} />
			) : (
				<AppText color="grayText" size="s" textAlign="center">
					{label && t(label as any)}
				</AppText>
			)}
		</EmptyStateWrapper>
	);
};

export default EmptyState;

const EmptyStateWrapper = styled.div<EmptyStateWrapperStyleProps>`
	height: 4.25rem;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: 0.7;
	background-color: ${(props) => props.theme.colors.COLOR_WHITE};
	margin: ${(props) => (props.margin ? props.margin : 0)};
`;
